// extracted by mini-css-extract-plugin
export default {"logo":"Navigation_logo__2HqbM","sidebar":"Navigation_sidebar__c+UdY","socialIcons":"Navigation_socialIcons__-Qewf","socials":"Navigation_socials__zZ02Z"};